import { gql } from '@apollo/client';

export const CURRENT_USER_ACTIVITIES = gql`
  query currentUserActivities($input: ActivityInput!) {
    activities: currentUserActivities(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          activityTargets {
            id
            endDate
            groupingType
            numberOfSessions
            expectedNumberOfAttendees
            plannedDuration
            startDate
            cohort {
              id
              name
            }
            frequency {
              id
            }
            frequencyType {
              id
            }
            institution {
              id
              name
            }
          }
          archivedSessionAttendees {
            id
          }
          stakeholderTypes {
            id
            name
          }
          attendeeCount
          audienceSize {
            id
            name
          }
          audienceType {
            id
            name
          }
          groupInstitutions {
            id
            name
          }
          groupCohorts {
            id
            name
          }
          inputTypes {
            id
            name
            quantity {
              quantity
            }
          }
          interfaceType {
            id
            name
          }
          intervention {
            id
            name
            fromDate
            toDate
          }
          interventions {
            id
            name
          }
          institutions {
            id
            name
          }
          cohorts {
            id
            name
          }
          name
          numberOfAttendees
          renderGroupForm
          multiDay
          weeklyTracking
          sunday
          monday
          tuesday
          wednesday
          thursday
          friday
          saturday
          historicalData
          weekStartDay
          numberOfDaysPerWeek
          totalExpectedAttendeesForSessionBasedActivity
          totalGroupFormAttendees
          sessionBasedAttendees
          serviceCategoriesCount
          servicesCount
          hiddenFieldsCount
          sessionAttendees {
            id
          }
          sessions {
            id
          }
          tags {
            name
          }
          targetAudiences {
            id
            name
          }
          targetGroup {
            id
            name
          }
          totalNumberOfSessions
          trackingLevel
          groupingType
          isArchived
          type {
            id
            name
          }
        }
      }
    }
  }
`;
